/** Domain-specific value lists shared across multiple components. */

import type { DvmsRole } from '../types/dvms.types';

export const ROLE_OPTIONS: DvmsRole[] = ['admin', 'project_admin', 'project_reader'];

export const ROLE_LABELS: Record<DvmsRole, string> = {
    admin: 'Admin',
    project_admin: 'Project Admin',
    project_reader: 'Reader',
};

export const ROLE_COLORS: Record<DvmsRole, 'error' | 'warning' | 'default'> = {
    admin: 'error',
    project_admin: 'warning',
    project_reader: 'default',
};

export const PROJECT_TYPES: string[] = ['Feature', 'Series', 'Short', 'Documentary', 'Commercial', 'Trailer'];

/**
 * Unit of measure values exactly as stored in the backend sys_configs
 * (`service_unit`), which the API also stores on every line item and rate card.
 * The dropdowns list sys_configs itself; these name the units the UI treats
 * specially.
 *
 * "per episode" (DUBVM-111) is a labelling distinction only: it prices exactly
 * like "flat rate" — the user enters the quantity, and only "per minute" is
 * derived from the project runtime.
 *
 * "Markup %" was retired as a selectable unit (DUBVM-77): it duplicated the
 * markup-on-top rate formula that already applies to every unit whenever a
 * markup value is set, and conflated Unit (how a cost is measured) with
 * Markup (how the rate is derived).
 */
export const UNIT_TYPES = {
    PER_MINUTE: 'per minute',
    FLAT_RATE: 'flat rate',
    PER_EPISODE: 'per episode',
} as const;

/** Unit of measure options for backsheet line items. */
export const UNITS: string[] = [UNIT_TYPES.PER_MINUTE, UNIT_TYPES.FLAT_RATE, UNIT_TYPES.PER_EPISODE];

/** Sys-config type keys used in listSysConfigs(). */
export const SYS_CONFIG_TYPES = {
    PROJECT_STATUS: 'project_status',
    SERVICE_UNIT: 'service_unit',
} as const;

/** Well-known project status values. */
export const PROJECT_STATUS_VALUES = {
    CREATED: 'created',
} as const;

/** Entity names used for notes/attachments linking. */
export const ENTITY_NAMES = {
    PROJECT: 'project',
    QUOTES: 'quotes',
    NOTE: 'note',
} as const;
